import axios from "axios";

export async function fetchCnpjData(cnpj) {
    const cleanCnpj = cnpj.replace(/\D/g, "");
    const { data } = await axios.get(
        `https://brasilapi.com.br/api/cnpj/v1/${cleanCnpj}`
    );
    return data;
}
